var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'text-md',
    {
      'text-green-400': _vm.value > 0,
      'text-red-400': _vm.value < 0,
      'text-gray-400': _vm.value === 0,
    } ]},[_vm._v("\n  "+_vm._s(_vm.textBefore)+"\n  "),_c('span',{class:[
      'inline-block transform',
      {
        '-rotate-90': _vm.value > 0,
        'rotate-90': _vm.value < 0,
      } ]},[_vm._v("\n    "+_vm._s(_vm.value === 0 ? "━" : "➜")+"\n  ")]),_vm._v("\n  "+_vm._s(_vm.textAfter)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }